import { useEffect } from 'react'
import CustomTab from 'components/tab/CustomTab'
import TabGroup from 'components/tab/TabGroup'
import { isEqual } from 'lodash'
import { useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import PrescriptionOrder from './PrescriptionOrder'
import { useDispatch } from 'react-redux'
import { setAddress } from 'redux/slices/addressSlice'

const PrescriptionList = () => {
  const currentPath = '/prescription'
  const navigate = useNavigate()
  const searchParam = useLocation().search
  const dispatch = useDispatch()

  const [activeTab, setActiveTab] = useState(undefined)
  const [page, setPage] = useState(1)

  useEffect(() => {
    const param = new URLSearchParams(searchParam)
    const tabParamValue = param.get('tab')
    const pageParamValue = param.get('page')
    if (tabParamValue === tabItems[0].title || tabParamValue === null) {
      setActiveTab(tabItems[0])
      setTabParams(tabItems[0], pageParamValue ?? 1)
    } else if (tabParamValue === tabItems[1].title) {
      setActiveTab(tabItems[1])
      setTabParams(tabItems[1], pageParamValue ?? 1)
    } else {
      setActiveTab(tabItems[2])
      setTabParams(tabItems[2], pageParamValue ?? 1)
    }
  }, [])

  const updateTab = (tab) => {
    if (!isEqual(tab, activeTab)) {
      setPage(1)
      setTabParams(tab, 1)
    }
  }

  const setTabParams = (tab, page) => {
    setActiveTab(tab)
    setPage(parseInt(page))
    navigate(`${currentPath}?page=${page}&tab=${tab?.title}`, {
      replace: true,
    })
  }

  return (
    <div className="h-full">
      <div className="px-4 mb-16">
        <div className="flex">
          <div className="w-full space-y-5">
            <div className="w-3/5 bg-white grid grid-cols-1">
              <nav className="flex">
                {tabItems.map((tab) => (
                  <button
                    key={tab.title}
                    onClick={() => {
                      updateTab(tab)
                    }}
                    className={`focus:outline-none px-6 py-2 font-medium border-b-2 ${
                      activeTab === tab
                        ? 'text-rand-100  border-secondary-500'
                        : 'text-rand-200 border-transparent hover:border-rand-300'
                    }`}
                  >
                    {tab.title}
                  </button>
                ))}
              </nav>
            </div>
            <div className="w-full px-5 py-2 border rounded-lg">
              <PrescriptionOrder
                activeTab={activeTab}
                updateTab={setTabParams}
                page={page}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const tabItems = [
  {
    title: 'Viber',
    path: '/viber',
    prefix: 'viber',
    header: 'Messages from viber',
  },
  {
    title: 'Scanned',
    path: '/scanned',
    prefix: 'scanned',
    header: 'Scanned Orders',
    status: 'REQUESTED',
  },
  {
    title: 'Processing',
    path: '/processing',
    prefix: 'processing',
    header: 'Processing Orders',
    status: 'PROCESSING',
  },
]

export default PrescriptionList
